import { InputHTMLAttributes } from 'react'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import {
    Input,
    Label,
    ButtonLocate,
    ErrorText,
    InputLength
} from 'components/InputLabel/styles'

interface InputLabelProps extends InputHTMLAttributes<HTMLInputElement> {
    register: UseFormRegister<FieldValues>
    name: string
    label?: string
    toLocate?: boolean
    inputWidth?: string
    error?: {
        message: string
    }
    buttonToLocate?: {
        disabled: boolean
        styles: string
        onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
    }
    required?: boolean
    container?: string
    inputLength?: number
    countCharacters?: boolean
    errorStyle?: string
    onBlur?: () => void
}

const InputLabel: React.FC<InputLabelProps> = ({
    errorStyle,
    label,
    register,
    name,
    toLocate,
    inputWidth,
    buttonToLocate,
    error,
    required,
    container,
    inputLength,
    onBlur,
    countCharacters = false,
    ...rest
}) => (
    <div className={container}>
        {label && <Label htmlFor="email">{label}</Label>}

        <div className={`flex items-center relative ${inputWidth}`}>
            <Input
                type="text"
                data-testid="input-label"
                className={`${error?.message && 'border border-errorText'} ${toLocate ? 'pr-24' : 'pr-4'} text-[16px]`}
                {...register(name, { required: required, onBlur: onBlur })}
                {...rest}
            />

            <ErrorText className={`${errorStyle}`}>{error?.message}</ErrorText>
            {
                countCharacters &&
                <InputLength className={inputLength === 0 && 'text-errorText'}>
                    {inputLength}{' '}
                    {inputLength === 1 ? 'caractere' : 'caracteres'}
                </InputLength>
            }

            {toLocate && (
                <ButtonLocate
                    type="button"
                    disabled={buttonToLocate?.disabled}
                    className={buttonToLocate?.styles}
                    onClick={buttonToLocate?.onClick}
                >
                    Localizar
                </ButtonLocate>
            )}
        </div>
    </div>
)

export { InputLabel }
